import { salesApiInstance } from './client.js';

export const usersApi = {
  getAll: (params = {}) => salesApiInstance.get('/users', { params }).then(r => r.data),
  getById: (id) => salesApiInstance.get(`/users/${id}`).then(r => r.data),
  create: (payload) => salesApiInstance.post('/users', payload).then(r => r.data),
  update: (id, payload) => salesApiInstance.put(`/users/${id}`, payload).then(r => r.data),
  remove: (id) => salesApiInstance.delete(`/users/${id}`).then(r => r.data),
  getLeads: (id) => salesApiInstance.get(`/users/${id}/leads`).then(r => r.data),
  getOrders: (id) => salesApiInstance.get(`/users/${id}/orders`).then(r => r.data),
};

export const teamApi = {
  getMembers: () => salesApiInstance.get('/team/members').then(r => r.data),
  getMyTL:    () => salesApiInstance.get('/team/my-tl').then(r => r.data),
  getTeamLeads: (params = {}) => salesApiInstance.get('/team/team-leads', { params }).then(r => r.data),
  getMembersByTlId: (id, params = {}) => salesApiInstance.get(`/team/${id}/members`, { params }).then(r => r.data),
};
